import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'approvalDetails.title',
    defaultMessage: 'Approval Details',
  },
  decision: {
    id: 'approvalDetails.decision',
    defaultMessage: 'Decision',
  },
  tier: {
    id: 'approvalDetails.tier',
    defaultMessage: 'Tier',
  },
  appNumber: {
    id: 'approvalDetails.appNumber',
    defaultMessage: 'Application Number',
  },
  prequalDate: {
    id: 'approvalDetails.prequalDate',
    defaultMessage: 'Pre-qualification Date',
  },
  deliveryDate: {
    id: 'approvalDetails.deliveryDate',
    defaultMessage: 'Delivery Date',
  },
  expirationDate: {
    id: 'approvalDetails.expirationDate',
    defaultMessage: 'Expiration Date',
  },
  maxRate: {
    id: 'approvalDetails.maxRate',
    defaultMessage: 'Max Rate',
  },
  maxTerm: {
    id: 'approvalDetails.maxTerm',
    defaultMessage: 'Max Term',
  },
  amountRequested: {
    id: 'approvalDetails.amountRequested',
    defaultMessage: 'Amount Requested',
  },
  actualLtv: {
    id: 'approvalDetails.actualLtv',
    defaultMessage: 'Actual LTV',
  },
  maxLtv: {
    id: 'approvalDetails.maxLtv',
    defaultMessage: 'Max LTV',
  },
  maxBackend: {
    id: 'approvalDetails.maxBackend',
    defaultMessage: 'Max Backend',
  },
  minCashDown: {
    id: 'approvalDetails.minCashDown',
    defaultMessage: 'Min Cash Down',
  },
  notes: {
    id: 'approvalDetails.notes',
    defaultMessage: 'Notes',
  },
  noNotes: {
    id: 'approvalDetails.noNotes',
    defaultMessage: 'No notes were found for this application.',
  },
  stipulations: {
    id: 'approvalDetails.stipulations',
    defaultMessage: 'Stipulations',
  },
  noStips: {
    id: 'approvalDetails.noStips',
    defaultMessage: 'No stipulations were currently found on this application.',
  },
  deliveryDateError: {
    id: 'approvalDetails.deliveryDateError',
    defaultMessage: 'An error occurred when trying to set the delivery date',
  },
});

export default messages;
